import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren, ReactNode } from 'react';
import './variant-fieldset.scss';
type VariantFieldsetProps = PropsWithChildren & {
  legendKey: string;
  legendValue: string;
  legendAction?: ReactNode;
};
export const VariantFieldset = t0 => {
  const $ = _c(14);
  const {
    legendKey,
    legendValue,
    legendAction,
    children
  } = t0;
  let t1;
  if ($[0] !== legendKey) {
    t1 = <span className="variants-fieldset__legend-key">{legendKey}:</span>;
    $[0] = legendKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== legendValue) {
    t2 = <span className="variants-fieldset__legend-value">{legendValue}</span>;
    $[2] = legendValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== legendAction) {
    t3 = legendAction && <div className="variants-fieldset__legend-action">{legendAction}</div>;
    $[4] = legendAction;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <legend className="variants-fieldset__legend">{t1}{t2}{t3}</legend>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== children || $[11] !== legendKey || $[12] !== t4) {
    t5 = <fieldset className="variants-fieldset" data-testid={legendKey}>{t4}{children}</fieldset>;
    $[10] = children;
    $[11] = legendKey;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};